module.exports = __webpack_public_path__ + "static/media/arrow-button-white.f545f678.svg";